import { render } from "./ShiftPermissionRequest.vue?vue&type=template&id=4aa5c000&scoped=true"
import script from "./ShiftPermissionRequest.vue?vue&type=script&lang=js"
export * from "./ShiftPermissionRequest.vue?vue&type=script&lang=js"

import "./ShiftPermissionRequest.vue?vue&type=style&index=0&id=4aa5c000&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa5c000"]])

export default __exports__